import { useMutation } from '@tanstack/react-query';
import { sendFormDismiss } from 'app/services/liveChat';
import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';

import { handleMutationSuccess } from './mutationSuccessHandler';

export default function useFetchFormDismiss() {
  const { data: helpCenter } = useFetchHelpCenter();
  const uuid = helpCenter?.uuid;
  const queryKey = ['liveChat', uuid];

  return useMutation({
    mutationFn: (data: { form_ref_id: unknown }) => sendFormDismiss({ uuid, data }),
    onSuccess: handleMutationSuccess(queryKey),
  });
}
